import { SOCIALS } from "../data/content";

const NAV_ITEMS = [
  { id: "home",     label: "Home" },
  { id: "about",    label: "About" },
  { id: "features", label: "Features" },
  { id: "contact",  label: "Contact" },
];

const PLANS_FOOTER = [
  { label: "Free — 15 Days",      id: "features" },
  { label: "Silver — ₹399/30d",   id: "features" },
  { label: "Gold — ₹2,199/6mo",   id: "features" },
  { label: "Diamond — ₹3,999/yr", id: "features" },
];

export default function Footer({ nav }) {
  return (
    <footer className="footer">
      <div className="ft">

        {/* Brand */}
        <div className="fb">
          <div className="fb-logo" onClick={() => nav("home")}>
            <img src="/logo.png" alt="Ooon Logo" className="logo-img" />
          </div>
          <p>Cloud-based restaurant POS &amp; billing software. Simple to use, built for every Indian food business.</p>
          <div className="fb-soc">
            {SOCIALS.map((s, i) => (
              <a key={i} href={s.url} target="_blank" rel="noopener noreferrer" className="fbs">
                {s.label}
              </a>
            ))}
          </div>
        </div>

        {/* Navigate */}
        <div className="fc2">
          <h5>Navigate</h5>
          {NAV_ITEMS.map((item) => (
            <button key={item.id} onClick={() => nav(item.id)}>{item.label}</button>
          ))}
        </div>

        {/* Plans */}
        <div className="fc2">
          <h5>Plans</h5>
          {PLANS_FOOTER.map((p, i) => (
            <button key={i} onClick={() => nav(p.id)}>{p.label}</button>
          ))}
        </div>

        {/* Company */}
        <div className="fc2">
          <h5>Company</h5>
          <a href="https://buyp.in" target="_blank" rel="noopener noreferrer">✦ Powered by Buyp</a>
          <a href="https://play.google.com/store/apps/details?id=com.Buyp.Ooon_App" target="_blank" rel="noopener noreferrer">Download App</a>
          <a href="https://buyp.in/privacy-policy-2/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
          <a href="https://buyp.in/terms-and-conditions/" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
          <button onClick={() => nav("contact")}>Contact Us</button>
        </div>

      </div>

      <div className="fb-btm">
        <p>
          © 2025 Ooon · Crafted with ✦ by{" "}
          <a href="https://buyp.in" target="_blank" rel="noopener noreferrer">Buyp</a>
          {" "}· Made in India 🇮🇳
        </p>
        <p>All rights reserved.</p>
      </div>
    </footer>
  );
}
